import { render, staticRenderFns } from "./EventCardFull.vue?vue&type=template&id=23f30714&"
import script from "./EventCardFull.vue?vue&type=script&lang=js&"
export * from "./EventCardFull.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports